import { KEY_CODES } from '../../constants';
import imgCropModalTemplate from './img-crop-modal.html';

class ImgCropCtrl {
  constructor($uibModal, $element: JQuery) {
    const ctrl: ng.IController = this;

    ctrl.$onInit = () => {
      ctrl.img = $element.find('.img-crop');
      ctrl.isBigger = true;
      $('img').on('load', (ev) => {
        // @ts-ignore
        ctrl.isBigger = (ev.currentTarget.naturalWidth > ctrl.img[0].scrollWidth) || (ev.currentTarget.naturalHeight > ctrl.img[0].scrollHeight);
      });
    };

    ctrl.showFullImage = () => {
      if (ctrl.isBigger) {
        $uibModal.open({
          animation: true,
          template: imgCropModalTemplate,
          controller: 'ModalCtrl',
          windowClass: 'img-crop-modal',
          resolve: {
            data() {
              return {
                src: ctrl.src,
                alt: ctrl.alt,
              };
            },
          },
        });
      }
    };

    ctrl.showFullImageByKeydown = function (event) {
      const keyDown = event.key !== undefined ? event.key : event.keyCode;
      if ((keyDown === 'Enter' || keyDown === KEY_CODES.RETURN) || (['Spacebar', ' '].indexOf(keyDown) >= 0 || keyDown === KEY_CODES.SPACE)) {
        ctrl.showFullImage();
      }
    };
  }
}

ImgCropCtrl.$inject = ['$uibModal', '$element'];

export default ImgCropCtrl;
